import React from "react";
import { Checkbox } from "antd";
import api from "../../../api";

const CustomCheckbox = ({ inputName, labelText, isChecked }) => {
  return (
    <Checkbox
      checked={isChecked}
      name={inputName}
      onChange={async e =>
        api.updateUserField({
          fieldName: e.target.name,
          fieldValue: e.target.checked ? 1 : 0
        })
      }
    >{labelText}</Checkbox>
  );
};

export default CustomCheckbox;
